import {checkIfReactionOnBehalfOfBotAllowed} from './checkIfReactionOnBehalfOfBotAllowed';

/**
 * От чьего имени текущий пользователь шлет реакции в матче.
 *
 * Обычно от своего. Админ, перехвативший управление ботом (см.
 * getActingPlayer), — от имени этого бота: своей игровой личности у зрителя
 * нет. Реакции от этого бота для него «свои»: тост не предлагает заглушить
 * самого себя.
 *
 * Явный бот реакций не шлет никогда, и сервер не примет их даже от
 * перехватившего админа (см. checkIfReactionOnBehalfOfBotAllowed) — говорить
 * админу не от кого, отправителя нет.
 *
 * @param {Array} players - игроки матча
 * @param {string|null} userId - id текущего пользователя
 * @returns {string|null} null — отправлять реакции нельзя
 */
export const getReactionSenderId = (players, userId) => {
  if (!userId) {
    return null;
  }
  const isMatchParticipant = (players || []).some((player) => player.id === userId);
  const controlledBot = isMatchParticipant
    ? null
    : (players || []).find((player) => player.isBot && player.botControlledByUserId === userId);
  if (!controlledBot) {
    return userId;
  }
  return checkIfReactionOnBehalfOfBotAllowed(controlledBot, userId) ? controlledBot.id : null;
};
